module.exports = __webpack_public_path__ + "static/media/check-icon.f66aa025.svg";